import { createBigDecimal } from '@0xtorch/big-decimal'
import type { Transfer } from '@0xtorch/core'
import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { createEvmAddressId } from '../../../../utils'
import { checkTransferIsMatchErc20Pattern } from './erc20Pattern'
import type { erc20TransferGeneratorSchema } from './schema'

export const generateTransfersByErc20Transfer = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof erc20TransferGeneratorSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): readonly Transfer[] => {
  const transfers: Transfer[] = []
  let currentIndex = -1
  for (const transfer of transaction.erc20Transfers) {
    const matched = checkTransferIsMatchErc20Pattern({
      transfer,
      schema,
      transaction,
      relatedAddresses,
    })
    if (matched) {
      currentIndex += 1
      if (schema.index === undefined || currentIndex === schema.index) {
        transfers.push({
          direction: schema.direction,
          from: createEvmAddressId({
            chainId: transaction.chainId,
            address: transfer.from,
          }),
          to: createEvmAddressId({
            chainId: transaction.chainId,
            address: transfer.to,
          }),
          asset: transfer.token.currency,
          amount: createBigDecimal(transfer.value, transfer.token.decimals),
        })
      }
      if (currentIndex === schema.index) {
        return transfers
      }
    }
  }
  if (schema.index === undefined) {
    return transfers
  }
  throw new Error('Matched ERC20 transfer is not found')
}
